<template>
  <v-container>
    <v-snackbar v-model="snackbar" :multi-line="true" :timeout="2000" :top="true">{{ snackbar_text }}</v-snackbar>
    <v-dialog
      v-model="dialogCreate"
      max-width="700px"
      transition="dialog-transition"
      v-if="dialogCreate"
    >
      <v-card class="no__padding">
        <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
          <h2>Vytvořit nového spolupracovníka</h2>
        </v-card-title>
        <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
          <v-form ref="createForm" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  :items="spolupracovnici_items"
                  v-model="newItem.typ_osoby"
                  label="Typ osoby"
                  item-value="value"
                  item-text="text"
                  class="mx-2"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="newItem.typ_osoby=='po'">
              <v-flex xs12>
                <v-flex xs12>
                  <v-text-field :label="newItem.typ_osoby=='po' ? 'Název firmy' : 'Název osoby'" v-model="newItem.nazev_firmy" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field label="IČ" class="mx-2" v-model="newItem.ic" v-if="newItem.typ_osoby=='po' || newItem.typ_osoby=='osvc'" :rules="rulesRequired"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="DIČ" class="mx-2" v-model="newItem.dic" v-if="newItem.typ_osoby=='po' || newItem.typ_osoby=='osvc'"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4 v-if="newItem.typ_osoby=='fo'">
                <v-text-field label="Titul před" class="mx-2" v-model="newItem.titul_pred"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Jméno" class="mx-2" v-model="newItem.jmeno" :rules="rulesRequired"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Příjmení" class="mx-2" v-model="newItem.prijmeni" :rules="rulesRequired"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="newItem.typ_osoby=='fo'">
                <v-text-field label="Titul za" class="mx-2" v-model="newItem.titul_za"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="newItem.typ_osoby=='fo' || newItem.typ_osoby=='osvc'">
                <datepicker label="Datum narození" class="mx-2" v-model="newItem.datum_narozeni"></datepicker>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm5>
                <v-text-field label="Ulice" v-model="newItem.ulice" class="mx-2" :rules="rulesRequired"></v-text-field>
              </v-flex>
              <v-flex xs12 sm5>
                <v-text-field label="Město" v-model="newItem.mesto" class="mx-2" :rules="rulesRequired"></v-text-field>
              </v-flex>
              <v-flex xs12 sm2>
                <v-text-field label="PSČ" v-model="newItem.psc" class="mx-2" :rules="rulesRequired"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm8>
                <v-text-field label="Účet" v-model="newItem.ucet" class="mx-2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Kód banky" v-model="newItem.ucet_kod_banky" class="mx-2"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <kraje label="Kraj" class="mx-2" v-model="newItem.kraj_id" :rules="rulesRequired"></kraje>
              </v-flex>
              <v-flex xs12 sm6 md8>
                <zpusoby-doruceni label="Způsob doručení" class="mx-0" v-model="newItem.zpusob_doruceni_id" :rules="rulesRequired"></zpusoby-doruceni>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Telefon" type="tel" class="mx-2" v-model="newItem.telefon" :rules="rulesRequired"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md8>
                <v-text-field label="Email" type="email" class="mx-2" v-model="newItem.email" :rules="rulesRequired"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field label="Oslovení do e-mailu" type="text" class="mx-2" placeholder="Např. Vážená paní / Vážený pane ..." v-model="newItem.osloveni" :rules="rulesRequired"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <v-spacer></v-spacer>
          <v-btn color="orange elevation-0" class="bold" dark @click="create" :loading="sending">Vytvořit</v-btn>
          <v-btn color="grey lighten-3 elevation-0" class="bold" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout row wrap v-if="!(me.podrizeny_maklere && !me.makler)">
      <v-spacer></v-spacer>
      <v-flex shrink>
        <v-btn color="orange" @click="createClick()" depressed dark class="bold ma-0 mt-2"><v-icon class="mr-2">add</v-icon>Přidat spolupracovníka</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="!(me.podrizeny_maklere && !me.makler) && !loading">
      <v-flex xs12>
        <!-- <h1 class="h2 mb-30">Spolupracovníci</h1> -->
        <v-layout row wrap class="mt-3">
          <v-flex grow>
            <div class="collaborator">
              <v-layout row wrap align-center>
                <v-flex grow>
                  <strong class="fs-12">{{me.cele_jmeno}}</strong>
                </v-flex>
                <v-flex shrink>
                  <obdobi hide-details class="ma-0" v-model="obdobi" v-if="!me.makler"></obdobi>
                  <v-menu offset-y right v-model="menu" :close-on-content-click="false" class="mx-2 d-flex grow" v-else>
                    <v-text-field
                      label="Datum"
                      v-model="datum"
                      slot="activator"
                      readonly
                      class="mx-0"
                      :class="{'mx-2': $vuetify.breakpoint.smAndUp}" clearable
                    ></v-text-field>
                    <v-card>
                      <v-card-text>
                        <DateRangePicker
                          :options="dateRangeOptions"
                          @input="onDateRangeChange"
                          :labels="labels"
                          @close="menu=false"
                        />
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="shop-layout mb-20">
          <v-flex xs12 class="mb-2 ml-4">
            <v-layout row wrap align-center>
              <v-flex shrink>
                <strong>Filtr <v-icon color="orange" class="filter-img">sort</v-icon></strong>
              </v-flex>
              <v-flex sm4 class="pl-3">
                <v-text-field
                  label="Hledáte něco konkrétního?"
                  autocomplete
                  solo
                  hide-details
                  append-icon="search"
                  v-model="search"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="items.length > 0">
          <v-flex xs12>
            <spolupracovnici-podrizeni :items="items" :makler="me.makler"></spolupracovnici-podrizeni>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else-if="items.length == 0 && !table">
          <v-flex xs12>
            <p class="body-1 text-center">
              <strong>Nebyly nalezeny žádné záznamy.</strong>
            </p>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  import DateRangePicker from '@/components/DateRange';
  export default {
    extends: Base,
    data () {
      return {
        counter: 0,
        loadingTable: false,
        loading: true,
        search: "",
        items: [],
        pagination: {
          descending: false,
          page: 1,
          rowsPerPage: 10,
          sortBy: "nazev_osoby",
          totalItems: 0,
          pages: 0,
          detail: false
        },
        snackbar: false,
        snackbar_text: null,
        obdobi: null,
        dialogCreate: false,
        dialogInit: {
          typ_osoby: "osvc",
          nazev_firmy: null,
          jmeno: null,
          prijmeni: null,
          titul_pred: null,
          titul_za: null,
          ic: null,
          dic: null,
          datum_narozeni: null,
          kraj_id: null,
          zpusob_doruceni_id: null,
          telefon: null,
          email: null,
          osloveni: null,
          ulice: null,
          mesto: null,
          psc: null,
          ucet: null,
          ucet_kod_banky: null
        },
        sending: false,
        newItem: null,
        rulesRequired: [
          (v) => !!v || "Pole je vyžadováno"
        ],
        valid: true,
        spolupracovnici_items: [{value: 'po', text: 'Právnická osoba'}, {value: 'osvc', text: 'OSVČ'}],
        datum_od: moment().startOf("month").format('YYYY-MM-DD'),
        datum_do: moment().format('YYYY-MM-DD'),
        dateRangeOptions: {
          startDate: moment().startOf("month").format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          format: 'DD.MM.YYYY',
          presets: [
            {
              label: 'Dnes',
              range: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
              ],
            },
            {
              label: 'Tento měsíc',
              range: [
                moment().startOf("month").format('YYYY-MM-DD'),
                moment().endOf("month").format('YYYY-MM-DD'),
              ],
            },
            {
              label: 'Minulý měsíc',
              range: [
                moment().subtract("months", 1).startOf("month").format('YYYY-MM-DD'),
                moment().subtract("months", 1).endOf("month").format('YYYY-MM-DD'),
              ],
            },
            {
              label: 'Tento rok',
              range: [
                moment().startOf("year").format('YYYY-MM-DD'),
                moment().endOf("year").format('YYYY-MM-DD'),
              ],
            },
            {
              label: 'Minulý rok',
              range: [
                moment().subtract("years", 1).startOf("year").format('YYYY-MM-DD'),
                moment().subtract("years", 1).endOf("year").format('YYYY-MM-DD'),
              ],
            }
          ],
        },
        range: [],
        labels: {
          start: "Začátek",
          end: "Konec"
        },
        menu: false,
        datum: null,
      }
    },
    watch: {
      obdobi () {
        this.load();
      },
      search () {
        this.load();
      },
      datum_od () {
        this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
      },
      datum_do () {
        this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
      }
    },
    computed: {
      me: function() {
        return window.$me;
      }
    },
    mounted () {
      this.load();
      this.datum = moment(this.datum_od).format("DD.MM.YYYY") + " - " + moment(this.datum_do).format("DD.MM.YYYY");
    },
    methods: {
      load (fn) {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("obchody/spolupracovnici/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter,
          obdobi: this.obdobi,
          datum_od: parseInt(moment(this.datum_od)._d.getTime()/1000),
          datum_do: parseInt(moment(this.datum_do)._d.getTime()/1000)
        }).then(function(body) {
          if (typeof fn == "function")
            fn();
          if (this.counter != body.echo)
            return;
          if (this.me.makler) {
            this.spolupracovnici_items = [{value: 'po', text: 'Právnická osoba'}, {value: 'osvc', text: 'OSVČ'}, {value: 'fo', text: 'Zaměstnanec'}];
          }
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.pagination.descending = body.sort.descending;
          this.loading = false;
          this.loadingTable = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      createClick () {
        this.newItem = window.th.copy(this.dialogInit);
        this.dialogCreate = true;
      },
      create () {
        if (this.$refs.createForm.validate()) {
          this.sending = true;
          this.checkPhone((_continue) => {
            if (_continue) {
              this.newItem.klient = true;
              this.newItem.spolupracovnik = false;
              window.API.post("obchody/spolupracovnici", this.newItem).then(function(body) {
                if (body.inserted) {
                  this.load(() => {
                    this.sending = false;
                    this.dialogCreate = false;
                  });
                }
                else {
                  this.sending = false;
                }
              }.bind(this)).catch(function(err) {
                console.log(err);
                this.sending = false;
              }.bind(this));
            }
            else {
              this.sending = false;
            }
          });
        }
      },
      checkPhone (f) {
        if (typeof this.newItem.telefon != "undefined" && this.newItem.telefon != null && this.newItem.telefon.length >= 9) {
          window.api.get("obchody/klienti/overit-telefon/" + this.newItem.telefon).then((_body) => {
            if (typeof _body.found !== "undefined") {
              if (_body.found) {
                f(false);
                this.snackbar = true;
                this.snackbar_text = "Telefonní číslo již existuje.";
              }
              else {
                f(true);
              }
            }
            else {
              f(false);
              this.snackbar = true;
              this.snackbar_text = "Nelze ověřit telefonní číslo.";
            }
          }).catch((err) => {
            console.log(err);
            f(false);
            this.snackbar = true;
            this.snackbar_text = "Nelze ověřit telefonní číslo.";
          });
        }
        else {
          f(false);
          this.snackbar = true;
          this.snackbar_text = "Neplatné telefonní číslo.";
        }
      },
      onDateRangeChange (e) {
        this.datum_od = parseInt(moment(e[0]).startOf("day")._d.getTime()/1000);
        this.datum_do = parseInt(moment(e[1]).endOf("day")._d.getTime()/1000);
        this.obdobi = null;
        this.load();
      }
    },
    components: {
      DateRangePicker
    }
  }
</script>
